(function ($) {
    window.dataLayer = window.dataLayer || [];

    $.fn.pick = function (how_many) {

        var how_many = how_many || 4;

        // Picking random numbers without repeating.
        var index_array = [];
        var original_obj_size = this.size();
        for (var i = 0; i < original_obj_size; i++) {
            index_array.push(i);
        }
        //+ Jonas Raoni Soares Silva
        //@ http://jsfromhell.com/array/shuffle [rev. #1]
        var shuffle = function (v) {
            for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x) ;
            return v;
        };
        var new_index_array = shuffle(index_array).slice(0, how_many);

        // Ditching unpicked elements and removing those from the returned set.
        return this.each(function (i) {
            if ($.inArray(i, new_index_array) === -1) {
                $(this).remove();
            }
        }).filter(function () {
            if (this.parentNode === null) {
                return false;
            } else {
                return true;
            }
        });

    };
})(jQuery);


$(document).ready(function () {
    if (window.location.href.indexOf("login") > -1) {
        $('.modal').addClass('active')
    }

    if ($('body').hasClass('template-policy')) {
        $('header').addClass('green_elements login');
    }

    if ($('.rct_content').length) {
        // $('header').remove();
        $('header').css('position', 'relative');
        $('header').addClass('green_elements login');
    }

    function triggerEvent(el, type) {
        if ('createEvent' in document) {
            // modern browsers, IE9+
            var e = document.createEvent('HTMLEvents');
            e.initEvent(type, false, true);
            el.dispatchEvent(e);
        } else {
            // IE 8
            var e = document.createEventObject();
            e.eventType = type;
            el.fireEvent('on' + e.eventType, e);
        }
    }

    $(document).keyup(function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            $(".cart_popup__close").trigger("click");
        }
    });

    $(".cart_popup__tint").on("click", function (e) {
        $(".cart_popup__close").trigger("click");
    })

    $(".copy_code_button").on("click", function (e) {
        var value = $(this).parent().find(".value_to_copy").text();
        navigator.clipboard.writeText(value);
        $(this).find(".copy_code_button__alert").fadeIn().delay(2000).fadeOut();
    })

    $('.single_checkbox').on('click', function () {
        $('.single_checkbox').removeClass('active');
        $(this).addClass('active');
        var currentCheckobx = $(this).text().trim();

        $(".size_select option").each(function (index, el) {
            if ($(this).val().trim() == currentCheckobx) {
                $(this).attr("selected", true).change();

                triggerEvent(document.querySelector('.size_select'), "change");
                // $(this).parent().val(currentCheckobx).change()
            } else {
                $(this).attr("selected", false).change();
            }
        });

    })

    // $('input,textarea').val("");
    $('#mc_embed_signup input, .login_wrap input, .register_wrap input, .login_wrap textarea, .register_wrap textarea, input #mc_embed_signup textarea, .mc_embed_form input').on("focusout", function () {
        var text_val = $(this).val();
        if (text_val === "") {
            $(this).removeClass('has-value');
            $(this).parents(".mc_embed_form").find(".subscribe-result").empty();
        } else {
            $(this).addClass('has-value');
        }
    });

    function getCurrentYear() {
        return new Date().getFullYear(); // returns the year via local timing
    };

    document.getElementById("year").innerHTML = getCurrentYear();

    if ($('#ReCharge').length) {
        $('header').addClass('green_elements login');
    }

    $(".article-template__content img:not(.glass-icon)").each(function () {
        var alt = $(this).attr("alt");

        if (alt && alt.length > 0) {
            var caption = $('<div class="article-template__image-caption">').text(alt)
            $(this).after(caption);
        }

        $(this).parents('p').css("margin-top", 0);

        $(this).wrap('<div class="article-template__image-wrap"></div>');
    })
})

window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type == 'submit') {
        setCookie('hide_popup', 1, 999);

        setTimeout(function(){
            $(".popup").fadeOut();
        }, 3000);
    }
});

$(document).on('ready', function () {
    // initScroll()
    fadeIn();
    $(".product__price").hide();
    $(".no-subscription .product__price").show();

    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
            setTimeout(function(){
                $(".klaviyo-form input").attr("autocomplete", "off");
            }, 1000);
        }
    });

    headerBackground();

    setTimeout(function () {
        jQuery('.cart_items .random').pick(2);
    }, 1000)


    $(".add-to-cart").on("click", function (e) {
        e.preventDefault();
        $(this).parent().prev().find('form').submit();
    });

    var hidePopup = getCookie('hide_popup');

    var uri = window.location.pathname;

    if(hidePopup != 1 && !window.customerId && (uri == '/' || uri.match('shop') || uri.match('product') ) ) {
        setTimeout(function(){
            $(".popup").fadeIn().css("display", "flex");
        }, 9000);
    }

    $(".popup__close").on("click", function (e) {
        e.preventDefault();
        $(this).parents(".popup").fadeOut();
        setCookie('hide_popup', 1, 30);
    });

    var product_list = new Swiper('.product_swiper_list', {
        slidesPerView: 1,
        effect: 'fade',
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {

                setTimeout(function () {
                    var counterCurrent = product_list.realIndex + 1;
                    var counterSlides = $('.product_swiper_list .swiper-slide').not('.swiper-slide-duplicate').length;
                    var currentColor = $('.product_swiper_list .swiper-slide-active').data('color');

                    $('.slider_counter .current').text(counterCurrent);
                    $('.slider_counter .total').text(counterSlides);
                    $('.slider_counter span, .slider_counter').css('color', currentColor);
                    $('.swiper-button-next svg path, .swiper-button-next svg line, .swiper-button-prev svg path, .swiper-button-prev svg line').css('stroke', currentColor);

                }, 100);
            },

            slideChangeTransitionStart: function () {
                var currentColor = $('.product_swiper_list .swiper-slide-active').data('color');
                $('.slider_counter span, .slider_counter').css('color', currentColor);
                $('.swiper-button-next svg path, .swiper-button-next svg line, .swiper-button-prev svg path, .swiper-button-prev svg line').css('stroke', currentColor);

            },

            slideChangeTransitionEnd: function () {
                setTimeout(function () {
                    $('.slider_counter .current').text(product_list.realIndex + 1);
                    // var currentColor = $('.product_swiper_list .swiper-slide-active').data('color');
                    // $('.slider_counter span, .slider_counter').css('color', currentColor);
                    // $('.swiper-button-next svg path, .swiper-button-next svg line, .swiper-button-prev svg path, .swiper-button-prev svg line').css('stroke', currentColor);

                }, 100);
            }
        }

    });

    var product_images_swiper = new Swiper('.product_images_swiper', {
        slidesPerView: 'auto',
        centeredSlides: true,
        // autoplay: {
        //     delay: 3000,
        // },
        pagination: {
            el: '.product_images_swiper .swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });

    var one_of_a_kinds = new Swiper('.one_of_a_kinds', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,

        pagination: {
            el: '.news_swiper .swiper-pagination',
            type: 'bullets',
            clickable: true
        },

        on: {
            init: function () {
                var currentCollection;
                var currentCollectionID;
                var currentIndex;

                if (!$('.swiper-slide-active').hasClass('view')) {
                    currentCollection = $('.swiper-slide-active').data('collectionname');
                    currentCollectionID = $('.swiper-slide-active').data('collectionid');
                    currentIndex = 0;

                    jQuery.getJSON('/products/' + $('.swiper-slide-active').data('handle') + '.js', function (product) {
                        dataLayer.push({ecommerce: null});
                        dataLayer.push({
                            event: "view_item_list",
                            ecommerce: {
                                items: [
                                    {
                                        item_id: product.id,
                                        item_name: product.title,
                                        affiliation: 'Shopify Store',
                                        coupon: '',
                                        currency: 'GBP',
                                        discount: '',
                                        index: currentIndex,
                                        item_brand: product.brand,
                                        item_category: product.type,
                                        item_list_id: currentCollectionID,
                                        item_list_name: currentCollection,
                                        item_variant: product.variants[0].name,
                                        price: product.variants[0].price * 0.01 + '.00',
                                        quantity: 1
                                    }
                                ]
                            }
                        });
                    })
                }

                $('.swiper-slide-active').addClass('view');
            }
        }
    });

    one_of_a_kinds.on('transitionEnd', function (e) {
        if (!$('.swiper-slide-active').hasClass('view')) {
            var currentCollection;
            var currentCollectionID;
            var currentIndex;

            currentCollection = $('.swiper-slide-active').data('collectionname');
            currentCollectionID = $('.swiper-slide-active').data('collectionid');
            currentIndex = one_of_a_kinds.activeIndex;

            jQuery.getJSON('/products/' + $('.swiper-slide-active').data('handle') + '.js', function (product) {
                dataLayer.push({ecommerce: null});
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: [
                            {
                                item_id: product.id,
                                item_name: product.title,
                                affiliation: 'Shopify Store',
                                coupon: '',
                                currency: 'GBP',
                                discount: '',
                                index: currentIndex,
                                item_brand: product.brand,
                                item_category: product.type,
                                item_list_id: currentCollectionID,
                                item_list_name: currentCollection,
                                item_variant: product.variants[0].name,
                                price: product.variants[0].price * 0.01 + '.00',
                                quantity: 1
                            }
                        ]
                    }
                });
            })
        }
        $('.swiper-slide-active').addClass('view');
    });

    var mixed_pack = new Swiper('.mixed_pack', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,

        pagination: {
            el: '.news_swiper .swiper-pagination',
            type: 'bullets',
            clickable: true
        },

        on: {
            init: function () {
                var currentCollection;
                var currentCollectionID;
                var currentIndex;

                if (!$('.swiper-slide-active').hasClass('view')) {
                    currentCollection = $('.swiper-slide-active').data('collectionname');
                    currentCollectionID = $('.swiper-slide-active').data('collectionid');
                    currentIndex = 0;

                    jQuery.getJSON('/products/' + $('.swiper-slide-active').data('handle') + '.js', function (product) {
                        dataLayer.push({ecommerce: null});
                        dataLayer.push({
                            event: "view_item_list",
                            ecommerce: {
                                items: [
                                    {
                                        item_id: product.id,
                                        item_name: product.title,
                                        affiliation: 'Shopify Store',
                                        coupon: '',
                                        currency: 'GBP',
                                        discount: '',
                                        index: currentIndex,
                                        item_brand: product.brand,
                                        item_category: product.type,
                                        item_list_id: currentCollectionID,
                                        item_list_name: currentCollection,
                                        item_variant: product.variants[0].name,
                                        price: product.variants[0].price * 0.01 + '.00',
                                        quantity: 1
                                    }
                                ]
                            }
                        });
                    })
                }

                $('.swiper-slide-active').addClass('view');
            }
        }
    });

    mixed_pack.on('transitionEnd', function (e) {
        var currentCollection;
        var currentCollectionID;
        var currentIndex;

        if (!$('.swiper-slide-active').hasClass('view')) {

            currentCollection = $('.swiper-slide-active').data('collectionname');
            currentCollectionID = $('.swiper-slide-active').data('collectionid');
            currentIndex = mixed_pack.activeIndex;

            jQuery.getJSON('/products/' + $('.swiper-slide-active').data('handle') + '.js', function (product) {
                dataLayer.push({ecommerce: null});
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: [
                            {
                                item_id: product.id,
                                item_name: product.title,
                                affiliation: 'Shopify Store',
                                coupon: '',
                                currency: 'GBP',
                                discount: '',
                                index: currentIndex,
                                item_brand: product.brand,
                                item_category: product.type,
                                item_list_id: currentCollectionID,
                                item_list_name: currentCollection,
                                item_variant: product.variants[0].name,
                                price: product.variants[0].price * 0.01 + '.00',
                                quantity: 1
                            }
                        ]
                    }
                });
            })
        }

        $('.swiper-slide-active').addClass('view');
    });

    $(".product_list .single_product").hover(function () {
        var hoverColor = $(this).find('.right .product_description').data('color');

        $(this).addClass('hover');
        $(this).find('.right .product_description h3').css('color', hoverColor);
        $(this).find('.right .product_description p').css('color', hoverColor);
    }, function () {
        var mainColor = '#1d8927';
        $(this).find('.right .product_description h3').css('color', mainColor);
        $(this).find('.right .product_description p').css('color', mainColor);
        $(this).removeClass('hover');
    });


    const loopContainer = document.querySelector('.loop-subscription-container');

    if (loopContainer) {
        bindLoopPurchaseOptionHandlers();
        waitForLoopWidget(loopContainer, initLoopWidget);
    }

    // Loop removes .loop-display-none only after its async init finishes; the container itself is in the HTML from the start.
    function waitForLoopWidget(container, callback) {
        let done = false;

        const run = function() {
            if (done) return;
            done = true;
            observer.disconnect();
            callback();
        };

        const observer = new MutationObserver(function() {
            if (!container.classList.contains('loop-display-none')) {
                run();
            }
        });

        observer.observe(container, { attributes: true, attributeFilter: ['class'] });

        if (!container.classList.contains('loop-display-none')) {
            run();
        }

        // Fallback so prices still show if Loop's init fails.
        setTimeout(run, 8000);
    }

    // Bound on load so they run after Loop's own handlers, including Loop's automatic click on the first plan group.
    function bindLoopPurchaseOptionHandlers() {
        $('body').delegate(".loop-one-time-purchase-option .radio-option", "click", function() {
            $(".radio-option").removeClass("radio-option--active");
            $(this).addClass("radio-option--active");
            $("input[name='selling_plan']").val("");

            $(".price__compare").hide();
            $(".price__subscription").hide();
            $(".price__onetime").show();
            updatePricePerGlass();
        })

        $('body').delegate(".loop-subscription-group .radio-option", "click", function() {
            $(".radio-option").removeClass("radio-option--active");
            $(this).addClass("radio-option--active");
            $("input[name='selling_plan']").val($(".loop-selling-plan-selector option[selected]").attr('value'));

            $(".price__onetime").hide();
            $(".price__compare").show();
            $(".price__subscription").show();
            updatePricePerGlass();
        })
    }

    function initLoopWidget() {
        window.loopDefaultOption = $(".loop-selling-plan-selector option[selected]");
        loopDefaultOption.each(function() {
            $(this).text($(this).text() + " (most popular)");
        });

        $('.loop-selling-plan-selector').tSelectbox();

        $('.loop-selling-plan-selector .custom-combobox').hide();

        $(".cs-option").on("click", function() {
            $("input[name='selling_plan']").val($(this).attr('value'))
        })

        window.loop_price_monitor_interval = setInterval(function () {
            $(".price__subscription").text($('[id*="loop-product-variant-"]:visible .loop-subscription-group-price-amount').first().text());
        }, 500)

        setTimeout(function () {
            clearInterval(window.loop_price_monitor_interval);
        }, 5000)

        if (!$(".loop-one-time-purchase-option-radio").is(":checked")) {
            $("input[name='selling_plan']").val(loopDefaultOption.attr('value'));
        }

        $(".price__compare, .price__onetime").text($(".loop-one-time-purchase-option-price-amount").text());
        $(".product__price").show();

        updatePricePerGlass();
    }

    const checkIfRCloadedInterval = setInterval(function() {
        if ($('.rc-container-wrapper').length) {
            initRCwidget();
        }
    }, 500);

    function initRCwidget() {
        clearInterval(checkIfRCloadedInterval);
        $('.rc-container-wrapper').remove();
        return;

        $('.product-form .rc-template__legacy-radio').append('<div class="option-description option-description--onetime"><ul><li>Free UK delivery on 2 or more boxes</li><li>Tracked, next day delivery</li></ul></div>');
        $('.product-form [data-plans-container]').prepend('<div class="option-description"><ul><li>10% off every order</li><li>Free UK delivery on 2 or more boxes</li><li>Tracked, next day delivery</li><li>Easily amend the frequency.</li><li>Skip or cancel anytime</li></ul></div>');
        $('.product-form .rc-selling-plans > select').show();
        $('.product-form .rc-template__legacy-radio').append($('.product-form [data-plans-container]'));

        var defaultOption = $(".product-form option[data-plan-option='Delivery: Every 6 Weeks']");

        if (defaultOption.length) {
            defaultOption.text(defaultOption.text() + " (most popular)");
        } else {
            defaultOption = $(".product-form option[data-plan-option]").first();
        }

        defaultOption.attr("selected","selected");
        defaultOption[0].selected = true;
        $('.product-form .rc-selling-plans > select').val(defaultOption.val());

        $('.rc_widget__option__plans__dropdown').tSelectbox();

        // fix RC changing selectbox value
        $("[data-selector-subsave]").click(function() {
            $("[data-plans-dropdown]").val($(".rc-selling-plans .cs-selected").attr("value"));
            $(".product__price .price__compare").show();
            updatePricePerGlass();
        })

        $("[data-selector-onetime]").click(function() {
            $(".product__price .price__compare").hide();
            updatePricePerGlass();
        })

        $('.single-option-selector').tSelectbox();

        $("#SingleOptionWrap-1 .cs-dropdown .cs-option").click(function() {
            let value = $("#SingleOptionWrap-1 .cs-dropdown [selected]").attr("value");

            //for subs
            $("#SingleOptionWrap-1 select").val(value);
            $("#SingleOptionWrap-1 option[value='"+value+"']").attr("selected","selected")
            $("#SingleOptionWrap-1 option:not([value='"+value+"'])").removeAttr("selected")

            //for onetime
            let selected = $(".product-form__variants option:contains('"+value+"')");
            let rest = $(".product-form__variants option:not(:contains('"+value+"'))");
            $(".product-form__variants").val(selected.attr("value"));
            selected.attr("selected","selected")
            rest.removeAttr("selected")
        });

        $(".price__compare").text($("[data-price-onetime]").text());
        $(".product__price").show();

        updatePricePerGlass();
    }

    function updatePricePerGlass() {
        setTimeout(function() {
            if ($(".no-subscription").length) {
                var new_price = $("[data-regular-price]").text().replace("£", "")/60;
            } else {
                if ($(".price__onetime").is(":visible")) {
                    var new_price = $(".price__onetime").text().replace("£", "")/80;
                }

                if ($(".price__subscription").is(":visible")) {
                    var new_price = $(".price__subscription").text().replace("£", "")/80;
                }
            }

            new_price = new_price * 100; //in pennies
            $(".price__per-glass__price").text((Math.round(new_price * 10) / 10).toFixed(1) + "p");
        }, 500)
    }

    $(".cart_icon").hover(function () {
        $(this).addClass('hovered');
    }, function () {
        $(this).removeClass('hovered');
    });

    if ($('.template-cart').length > 0) {
        dataLayer.push({ecommerce: null});
        const itemsList = [];
        $(".single_product_row").each(function (index) {
            jQuery.getJSON('/products/' + $(this).data('handle') + '.js', function (product) {
                itemsList.push(
                    {
                        item_id: product.id,
                        item_name: product.title,
                        affiliation: 'Shopify Store',
                        coupon: '',
                        currency: 'GBP',
                        discount: '',
                        item_brand: product.brand,
                        item_category: product.type,
                        // item_list_id: currentCollectionID,
                        // item_list_name: currentCollection,
                        item_variant: product.variants[0].name,
                        price: product.variants[0].price * 0.01 + '.00',
                        quantity: 1
                    }
                );
            })
        });

        dataLayer.push({
            event: "view_cart",
            ecommerce: {
                items: itemsList
            }
        });
    }

    $('.cart_icon').on('click', function (event) {
        dataLayer.push({ecommerce: null});
        const itemsCartList = [];

        event.stopImmediatePropagation();
        $('cart_icon').toggleClass('active');
        $('.cart_popup').toggleClass('active');
        $("header").addClass('white_header');
        $("header").removeClass('green_header');
        $(".mobile_nav").removeClass('active');
        $(".mobile_menu_opener").removeClass('opened');
        $(".cart_icon").removeClass('hovered');
        $("body").toggleClass('no_scroll');
        $(".mobile_cart_close_wrap").addClass('active');

        if ($('.cart_popup').hasClass('active')) {
            $(".single_product.standard").each(function (index) {
                jQuery.getJSON('/products/' + $(this).find('.remove_button').data('handle') + '.js', function (product) {
                    itemsCartList.push(
                        {
                            item_id: product.id,
                            item_name: product.title,
                            affiliation: 'Shopify Store',
                            coupon: '',
                            currency: 'GBP',
                            discount: '',
                            item_brand: product.brand,
                            item_category: product.type,
                            // item_list_id: currentCollectionID,
                            // item_list_name: currentCollection,
                            item_variant: product.variants[0].name,
                            price: product.variants[0].price * 0.01 + '.00',
                            quantity: 1
                        }
                    );
                })
            });

            setTimeout(function () {
                dataLayer.push({
                    event: "view_cart",
                    ecommerce: {
                        items: itemsCartList
                    }
                });
            }, 500)

        }

        setTimeout(function () {
            $("header").addClass("show");
        }, 10)

        // setTimeout(function(){
        //     if($('.cart_icon').hasClass('active')){
        //         $("body").addClass('no_scroll');
        //     } else{
        //         $("body").removeClass('no_scroll');
        //     }
        // }, 500)
    });

    $('.mobile_cart_close_wrap').on('click', function (event) {
        event.stopImmediatePropagation();
        $('.cart_icon').removeClass('active');
        $('.cart_popup').removeClass('active');
        $("body").removeClass('no_scroll');
        $('.mobile_cart_close_wrap').removeClass('active');
    });

    $('.cart_cta .link_holder, .cart_cta__continue').on('click', function (event) {
        event.stopImmediatePropagation();
        $('.cart_icon').removeClass('active');
        $('.cart_popup').removeClass('active');
        $("body").removeClass('no_scroll');
        $('.mobile_cart_close_wrap').removeClass('active');
    });

    $('.mobile_menu_opener').on('click', function (event) {
        event.stopImmediatePropagation();
        $(this).toggleClass('opened');
        $('.mobile_nav').toggleClass('active');
        $('header').toggleClass('green_header');
        $('.cart_icon').removeClass('active');
        $('.mobile_cart_close_wrap').removeClass('active');
        $('.cart_popup').removeClass('active');

        setTimeout(function () {
            if ($('.mobile_menu_opener').hasClass('opened')) {
                $("body").addClass('no_scroll');
            } else {
                $("body").removeClass('no_scroll');
            }
        }, 500)


    });

    $('.single_accrodion').on('click', function (event) {
        $(this).toggleClass('active');
        $(this).find('.description').slideToggle();
    });

    gsap.defaults({
        overwrite: true
    });

    const target = document.querySelector(".slide_content");
    if (target) {
        const clone = target.cloneNode(true);
        target.after(clone);

        const tl = gsap
            .to(".slide_content", {duration: 30, xPercent: -100, ease: "none", repeat: -1})
            .timeScale(0);
        gsap.to(tl, {timeScale: 1});
    }


    $(".image_banner .image_holder, .hero_with_description .image_holder").addClass('in-view');

    var lastScrollTop = 0;
    $(window).on('scroll', function (event) {
        fadeIn();

        if ($('.shop_page').length > 0 && $(window).width() > 750) {
            getInViewProducts();
        }

        headerBackground();

        if ($(document).scrollTop() > 200) {
            $("header").addClass("fixed");

            var st = $(this).scrollTop();
            if (st > lastScrollTop) {
                // downscroll code
                $("header").removeClass("show");
            } else {
                // upscroll code
                $("header").addClass("show");
            }
            lastScrollTop = st;
        } else {
            if ($("header").hasClass("fixed")) {
                //   $("header").removeClass("show");

                setTimeout(function () {
                    $("header").removeClass("fixed");
                }, 50);
            } else {
                $("header").removeClass("fixed");
            }
        }


    });

    function headerBackground() {
        if ($(this).scrollTop() > 0) {
            $("header").addClass('scrolled white_header');

        } else if (!$(".cart_popup").hasClass('active')) {
            $("header").removeClass('scrolled white_header');
        }

        if ($("header").hasClass('scrolled')) {
            $(".cart_popup, .mobile_nav").addClass('scrolled');

        } else {
            $(".cart_popup, .mobile_nav").removeClass('scrolled');
        }
    }

    var findMiddleElement = (function (docElm) {
        var viewportHeight = docElm.clientHeight,
            // here i'm using pre-cached DIV elements, but you can use anything you want.
            // Cases where elements are generated dynamically are more CPU intense ofc.
            elements = $(".category_headlines .headline");

        return function (e) {
            var middleElement;
            if (e && e.type == "resize") viewportHeight = docElm.clientHeight;

            elements.each(function () {
                var pos = this.getBoundingClientRect().top;
                // if an element is more or less in the middle of the viewport
                if (pos > viewportHeight / 2.5 && pos < viewportHeight / 1.5) {
                    middleElement = this;
                    $(".category_headlines .headline").removeClass("middle");
                    $(this).addClass("middle");
                    return false; // stop iteration
                }
            });
        };
    })(document.documentElement);
    $(window).on("scroll resize", findMiddleElement);


    var pos = 0;

    setTimeout(function () {
        pos = $(document).scrollTop();
    }, 500)

});

$(window).on("load", function () {
    var oldImage;
    // Clear the previous ecommerce object.
    dataLayer.push({ecommerce: null});

    if ($(window).width() > 765) {
        $(".single_choice").hover(function () {
            var currentDescription = $(this).data('description');
            oldImage = $(this).parent().parent().parent().find('.image_holder img').attr('src');
            var currentImage = $(this).data('image');
            $(this).parent().parent().parent().find('.box_info').text(currentDescription).addClass('active');
            $(this).parent().parent().parent().find('.image_holder img').attr('src', currentImage);

        }, function () {
            $(this).parent().parent().parent().find('.box_info').removeClass('active');
            $(this).parent().parent().parent().find('.image_holder img').attr('src', oldImage);
        });
    }


    $('.swiper-slide .opener').on('click', function (event) {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).parent().find('.choices').toggleClass('remove');
            $(this).parent().find('.mobile_choices').slideDown();
        } else {
            $(this).removeClass('active');
            $(this).parent().find('.mobile_choices').css('display', 'none');
            $(this).parent().find('.choices').toggleClass('remove').slideDown();

        }

    });

    var featured_products = new Swiper('.featured_products', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,
        // autoplay: {
        //     delay: 3000,
        // },
        pagination: {
            el: '.news_swiper .swiper-pagination',
            type: 'bullets',
            clickable: true
        }
    });
});


//MEASURE VIEWED PRODUCT ON SINGLE PRODUCT PAGE(WHEN PAGE IS OPENED)
setTimeout(function () {
    if ($('.template-product').length > 0) {
        var currentCollection;
        var currentCollectionID;

        currentCollection = $('.product-template__container').data('collections');
        currentCollectionID = $('.product-template__container').data('collectionsid');

        jQuery.getJSON('/products/' + $('.product-template__container').data('handle') + '.js', function (product) {
            dataLayer.push({ecommerce: null});
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.title,
                            affiliation: 'Shopify Store',
                            coupon: '',
                            currency: 'GBP',
                            discount: '',
                            item_brand: product.brand,
                            item_category: product.type,
                            item_list_id: currentCollectionID,
                            item_list_name: currentCollection,
                            item_variant: product.variants[0].name,
                            price: product.variants[0].price * 0.01 + '.00',
                            quantity: 1
                        }
                    ]
                }
            });
        })
    }
}, 2000)

//MEASURE CLICKED PRODUCT ON COLLECTION PAGE
if ($('.shop_page').length > 0) {

    $('.single_box').on('click', function () {
        jQuery.getJSON('/products/' + $(this).data('handle') + '.js', function (product) {
            dataLayer.push({ecommerce: null})
            dataLayer.push({
                event: "select_item",
                ecommerce: {
                    items: [
                        {
                            item_id: product.id,
                            item_name: product.title,
                            affiliation: 'Shopify Store',
                            coupon: '',
                            currency: 'GBP',
                            discount: '',
                            index: currentIndex,
                            item_brand: product.brand,
                            item_category: product.type,
                            item_list_id: currentCollectionID,
                            item_list_name: currentCollection,
                            item_variant: product.variants[0].name,
                            price: product.variants[0].price * 0.01 + '.00',
                            quantity: 1
                        }
                    ]
                }
            });
        })
    })
}

//MEASURE VIEWED PRODUCTS ON COLLECTION PAGE
function getInViewProducts() {
    var winHeight = $(window).height();
    var bodyScroll = $(document).scrollTop();
    var calcHeight = bodyScroll + winHeight;
    var currentCollection;
    var currentCollectionID;
    var currentIndex;

    $('.single_box').each(function (index, el) {
        if ($(this).offset().top < calcHeight && $(this).offset().top + $(this).height() > bodyScroll) {
            if (!$(this).hasClass('view')) {

                currentCollection = $(this).data('collectionname');
                currentCollectionID = $(this).data('collectionid');
                currentIndex = $(this).data('index');

                jQuery.getJSON('/products/' + $(this).data('handle') + '.js', function (product) {
                    // console.log(product)
                    dataLayer.push({ecommerce: null});
                    dataLayer.push({
                        event: "view_item_list",
                        ecommerce: {
                            items: [
                                {
                                    item_id: product.id,
                                    item_name: product.title,
                                    affiliation: 'Shopify Store',
                                    coupon: '',
                                    currency: 'GBP',
                                    discount: '',
                                    index: currentIndex,
                                    item_brand: product.brand,
                                    item_category: product.type,
                                    item_list_id: currentCollectionID,
                                    item_list_name: currentCollection,
                                    item_variant: product.variants[0].name,
                                    price: product.variants[0].price * 0.01 + '.00',
                                    quantity: 1
                                }
                            ]
                        }
                    });
                })
            }

            $(this).addClass('view');
        }
    });
};

function fadeIn() {
    var winHeight = $(window).height();
    var bodyScroll = $(document).scrollTop();
    var calcHeight = bodyScroll + winHeight;

    $('.fadein-wrap').each(function (index, el) {
        if ($(this).offset().top < calcHeight && $(this).offset().top + $(this).height() > bodyScroll) {
            if (!$(this).hasClass('in-view')) {
                $(this).addClass('in-view');
            }
        }
    });
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}